// @generated by protoc-gen-connect-es v1.6.1
// @generated from file omnios/v1/team_email.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CreateTeamEmailRequest, DeleteTeamEmailRequest, GetTeamEmailDomainRequest, GetTeamEmailDomainResponse, GetTeamEmailRequest, ListTeamEmailsRequest, ListTeamEmailsResponse, PauseTeamEmailRequest, PreviewTeamEmailRequest, PreviewTeamEmailResponse, ResumeTeamEmailRequest, TeamEmail } from "./team_email_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service omnios.v1.TeamEmailService
 */
export const TeamEmailService = {
  typeName: "omnios.v1.TeamEmailService",
  methods: {
    /**
     * @generated from rpc omnios.v1.TeamEmailService.CreateTeamEmail
     */
    createTeamEmail: {
      name: "CreateTeamEmail",
      I: CreateTeamEmailRequest,
      O: TeamEmail,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.TeamEmailService.GetTeamEmail
     */
    getTeamEmail: {
      name: "GetTeamEmail",
      I: GetTeamEmailRequest,
      O: TeamEmail,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.TeamEmailService.PauseTeamEmail
     */
    pauseTeamEmail: {
      name: "PauseTeamEmail",
      I: PauseTeamEmailRequest,
      O: TeamEmail,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.TeamEmailService.ResumeTeamEmail
     */
    resumeTeamEmail: {
      name: "ResumeTeamEmail",
      I: ResumeTeamEmailRequest,
      O: TeamEmail,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.TeamEmailService.DeleteTeamEmail
     */
    deleteTeamEmail: {
      name: "DeleteTeamEmail",
      I: DeleteTeamEmailRequest,
      O: TeamEmail,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.TeamEmailService.ListTeamEmails
     */
    listTeamEmails: {
      name: "ListTeamEmails",
      I: ListTeamEmailsRequest,
      O: ListTeamEmailsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.TeamEmailService.PreviewTeamEmail
     */
    previewTeamEmail: {
      name: "PreviewTeamEmail",
      I: PreviewTeamEmailRequest,
      O: PreviewTeamEmailResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.TeamEmailService.GetTeamEmailDomain
     */
    getTeamEmailDomain: {
      name: "GetTeamEmailDomain",
      I: GetTeamEmailDomainRequest,
      O: GetTeamEmailDomainResponse,
      kind: MethodKind.Unary,
    },
  }
};

